// extracted by mini-css-extract-plugin
module.exports = {"buttonPanel":"Overview_buttonPanel__36nOB","button":"Overview_button__1VkYb","active":"Overview_active__1frFR"};